<ul
  class="nav-tabs"
  data-test="stream-tabs-container"
  role="tablist"
  *ngIf="tabList$ | async as tabs"
  [ngClass]="{ 'no-tabs': !tabs.length }"
>
  <li
    *ngFor="let tab of tabs; let i = index; trackBy: trackByTab"
    floAnalytics
    tagName="Tab"
    events="click"
    [analyticsProperties]="tab.analyticProps"
    class="primary-color-text-active live-tab-item"
    (click)="selectTab(tab.title)"
    [class.active]="tab.isActive"
    #tabContainer
    [ngClass]="{'live-results-tab': tab.title === 'live results'}"
  >
    <a
      class="live-nav-link p-0 h-100 w-100 d-flex align-items-center justify-content-center"
      data-test="stream-tabs"
      >{{ tab.title }}</a
    >
  </li>
  <div #tabSlider class="slider"></div>
</ul>
<ng-content select="flo-live-tab"></ng-content>
